import { useRouter } from 'next/router'
import { useCallback } from 'react'

export const useCustomRouter = () => {
  const router = useRouter()
  const query = router.query

  function isString(value: string | string[] | undefined): value is string {
    return typeof value === 'string'
  }

  /**
   * receive newQuery and replace query parameters by taking over previous queries
   *
   * @param {Object} newQueries
   *
   */
  const replaceQueriesWithPrevious = (newQueries: {
    [key: string]: string | string[] | undefined
  }) => {
    router.replace({
      pathname: router.pathname,
      query: {
        ...query,
        ...newQueries,
      },
    })
  }

  /**
   * receive newQuery and replace all query parameters
   *
   * @param {Object} newQueries
   *
   */
  const replaceAllQueries = useCallback(
    (newQueries: { [key: string]: string | string[] | undefined }) => {
      router.replace({
        pathname: router.pathname,
        query: newQueries,
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return { router, isString, replaceQueriesWithPrevious, replaceAllQueries }
}
